export default {
  OTP_FEATURE_ILL_ONLINE: false
};
